<template>
    <div class="menu-left left">
        <div class="LayoutNav">
            <div class="main">
                <el-menu
                        :router="true"
                        :background-color="'#fff'"
                        :text-color="'#000'"
                        :active-text-color="'#000'"
                        :default-active="activeUrl"
                >
                    <left-menu-item v-for="(item, index) in menuList" :key="index" :obj="item"></left-menu-item>
                </el-menu>
            </div>
        </div>
    </div>
</template>

<script>
    import * as API from "../api/global.js"
    import LeftMenuItem from "./LeftMenuItem";
    import { mapState } from "vuex"
    import {mapActions} from "vuex"
    export default {
        name: 'LeftMenu',
        components:{LeftMenuItem},
        data(){
            return{
                activeUrl:'/home',
                /*menuList:[
                    {vc_name:"用户管理", vc_url:"/users"},
                    {vc_name:"角色列表", vc_url:"/roleList"},
                    {vc_name:"菜单管理", vc_url:"/MenuList"},
                    {vc_name:"主数据管理", vc_url:"/MasterDataManagement",
                        smenuList:[

                                    { vc_name:"客商主数据",vc_url:"/MasterDataManagement/ks"},
                                    { vc_name:"公司主数据",vc_url:"/MasterDataManagement/company"},
                                    { vc_name:"部门主数据",vc_url:"/MasterDataManagement/group"},
                                    { vc_name:"人员主数据",vc_url:"/MasterDataManagement/person"},
                                    { vc_name:"国家省份城市主数据",vc_url:"/MasterDataManagement/area"},
                                    { vc_name:"计量单位主数据",vc_url:"/MasterDataManagement/unit"},
                                    { vc_name:"币种主数据",vc_url:"/MasterDataManagement/currency"},
                                    { vc_name:"产品主数据",vc_url:"/MasterDataManagement/productRelation"},
                                         ]
                    },
                    {vc_name:"业务系统导入", vc_url:"/businessSystemImport",
                        smenuList:[
                            { vc_name:"客商",vc_url:"/businessSystemImport/ks"},
                            { vc_name:"公司",vc_url:"/businessSystemImport/company"},
                            { vc_name:"部门",vc_url:"/businessSystemImport/group"},
                            { vc_name:"人员",vc_url:"/businessSystemImport/person"},
                            { vc_name:"国家省份城市",vc_url:"/businessSystemImport/area"},
                            { vc_name:"计量单位",vc_url:"/businessSystemImport/unit"},
                            { vc_name:"币种",vc_url:"/businessSystemImport/currency"},
                            { vc_name:"产品",vc_url:"/businessSystemImport/productName"},

                            //              { vc_name:"新增挂牌",menu_path:"/product/productOnSale"},
                        ]
                    }

                ]*/
            }
        },
        computed:{
            ...mapState(["routerList","menuList"]),
        },
        watch:{
            $route(to){
                this.activeUrl = to.path;
                this.pushVisitedView(to)
            }
        },
        mounted() {
            console.log(this.routerList)
            /*if(this.routerList.length >0 ){
                let path=this.routerList[0].path;
            }*/

            console.log(this.activeUrl)
            if(this.routerList.length > 0 && this.activeUrl!="/home"){
                this.$router.push({path: path})
            }
            this.changeActiveUrl();
        },
        methods:{
            ...mapActions(["addView","addVisitedView"]),
            initTags(){
                const affixTags=this.affixTags=this.filterAffixTags(this.routes);
                for (const tag of affixTags){
                    if(tag.name){
                        this.$store.dispath('store/addVisitedView',tag)
                    }
                }
            },
            filterAffixTags(routes, basePath ="/"){
                let tags= [];
                routes.forEach(route => {
                    if(route.meta && route.meta.affix){
                        const tagPath =path.resolve(basePath,route.path)
                        tags.push({
                            fullPath:tagPath,
                            path:tagPath,
                            name:route.name,
                            meta:{...route.meta}
                        })
                    }
                    if(route.children){
                        const temTags =this.filterAffixTags(route.children,route.path);
                        if(tempTags.length >= 1){
                            tags = [...tags, ...tempTags]
                        }
                    }
                })
                return tags
            },
            changeActiveUrl(){
                this.activeUrl = this.$route.path;
            },
            pushVisitedView(view){
                this.addView(view);
            },
        }
    }
</script>
<style  lang="scss" scoped>
    .menu-left{
        margin-top: 3px;
    }
    .left{
        height: calc(100vh - 100px);
        width: 250px;
        overflow-y: auto;
        -ms-overflow-y: auto;
    }
    .scroll{
        overflow-y: auto;
        -ms-overflow-y: auto;
    }
  .LayoutNav{

      height: 100%;
      background-color: #fff;

      .main{

          /deep/{
              .el-meun{
                  border-right: none;
              }
              .el-menu-item.is-active{
                  background-color:#dfdcdc !important;
              }
          }
      }
  }

</style>